import React from 'react';
import { connect } from 'react-redux';
import withStyles from 'react-jss';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import { getTenantState } from '../../store/selectors';

const iconStyles = {
  textColor: (props) => ({
    color: props.tenant.primary,
  }),
};

function SunIcon({
  className,
  value,
  width,
  marginRight,
  additionalClassName,
  textColor,
  setParentOnClick,
  ...props
}) {
  const { t } = useTranslation();
  const fillColor = 'gold';

  const handleOnClick = () => {
    if (setParentOnClick) setParentOnClick();
  };

  return (
    <div
      role="button"
      tabIndex={0}
      className={classNames({
        'career-outlook-icon-container': true,
        [additionalClassName]: additionalClassName,
        on: value !== undefined ? value : null,
      })}
      aria-label={`Click here to open the bright outlook information modal`}
      onClick={() => handleOnClick()}
      onKeyDown={(e) => {
        if (['Enter'].includes(e.key)) handleOnClick();
      }}
    >
      {value ? (
        <p
          className={classNames({
            'toggle-button-text': true,
            'on-label': true,
            [props.classes.textColor]: true,
          })}
        >
          {t('On')}
        </p>
      ) : null}
      <svg
        style={{ marginRight: marginRight }}
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        x="0px"
        y="0px"
        viewBox="0 0 1000 1000"
        width={width || '20px'}
        role="img"
      >
        <title>{t('Bright Outlook')}</title>
        <g>
          <path
            fill={fillColor}
            d="M271.23,502.42c0,126.59,102.62,229.21,229.21,229.21S729.65,629,729.65,502.42S627.03,273.21,500.44,273.21l0,0
		c-126.43-0.16-229.05,102.2-229.21,228.62C271.23,502.02,271.23,502.22,271.23,502.42z"
          />
          <path
            fill={fillColor}
            d="M500.44,169.29c-28.78,0-52.11-23.33-52.11-52.11c0,0,0,0,0,0V54.53c-2.16-28.7,19.36-53.71,48.06-55.86
		c28.7-2.16,53.71,19.36,55.86,48.06c0.2,2.6,0.2,5.21,0,7.81v62.35c0.32,28.61-22.61,52.07-51.22,52.4
		C500.83,169.28,500.64,169.29,500.44,169.29z M500.44,1002.4c-28.78,0-52.11-23.33-52.11-52.11v-62.35
		c-2.16-28.7,19.36-53.71,48.06-55.86c28.7-2.16,53.71,19.36,55.86,48.06c0.2,2.6,0.2,5.21,0,7.81v62.35
		c0.16,28.62-22.9,51.94-51.52,52.11C500.64,1002.4,500.54,1002.4,500.44,1002.4z M266.26,268.23c-20.1,20.37-52.9,20.59-73.27,0.49
		c-0.17-0.16-0.33-0.33-0.49-0.49l-44.2-44.2c-20.37-20.1-20.59-52.9-0.49-73.27c0.16-0.17,0.33-0.33,0.49-0.49
		c20.42-20.24,53.34-20.24,73.77,0l44.2,42.74c20.77,20.15,21.28,53.32,1.14,74.09C267.02,267.48,266.64,267.86,266.26,268.23z
		 M854.06,856.04c-20.42,20.24-53.34,20.24-73.77,0l-44.2-44.2c-19.5-21.16-18.16-54.12,3-73.63c19.89-18.34,50.51-18.4,70.48-0.14
		l44.5,44.2C874.3,802.69,874.3,835.61,854.06,856.04z M266.26,738.07c20.24,20.42,20.24,53.34,0,73.77l-44.2,44.2
		c-20.42,20.24-53.34,20.24-73.77,0c-20.37-20.1-20.59-52.9-0.49-73.27c0.16-0.17,0.33-0.33,0.49-0.49l44.2-44.2
		C212.91,717.82,245.83,717.82,266.26,738.07z M854.06,148.79c20.24,20.42,20.24,53.34,0,73.77l-44.5,45.67
		c-21.24,19.42-54.2,17.94-73.62-3.29c-18.26-19.97-18.2-50.58,0.14-70.48l44.2-44.2C800.31,129.61,833.24,128.95,854.06,148.79z
		 M167.02,502.42c0.16,28.62-22.9,51.94-51.52,52.11c-0.1,0-0.2,0-0.29,0H52.56c-28.78,0.01-52.12-23.3-52.13-52.08
		c-0.01-28.78,23.3-52.12,52.08-52.13c0.02,0,0.03,0,0.05,0h62.64C143.87,450.47,167.02,473.75,167.02,502.42z M1000.43,502.42
		c0,28.78-23.33,52.11-52.11,52.11h-62.64c-28.78-0.01-52.09-23.35-52.08-52.13c0.01-28.76,23.32-52.07,52.08-52.08h62.64
		C977.1,450.31,1000.43,473.64,1000.43,502.42C1000.43,502.42,1000.43,502.42,1000.43,502.42z"
          />
        </g>
      </svg>
      {value === false ? (
        <p className="toggle-button-text off-label">{t('Off')}</p>
      ) : null}
    </div>
  );
}

function mapStateToProps(state) {
  const tenant = getTenantState(state);

  return { tenant };
}

export default connect(mapStateToProps)(withStyles(iconStyles)(SunIcon));
